import { FC } from 'react';
import { Tabs } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../Localization';
import { RightSidebarProps } from './shared/types';
import { CaseNotesTab } from './components/CaseNotesTab';
import { ToolsTab } from './components/ToolsTab';
import { PhoneTab } from './components/PhoneTab';
import { SupportedLanguage } from '../../../Context';

export const RightSidebar: FC<RightSidebarProps> = ({
  caseInfo,
  applicantUid,
  verifiedContacts,
  applicantInfo,
  channel
}) => {
  const L = useLocalizedStrings();

  const tabs = [
    {
      key: 'phone',
      name: L.support.phone,
      content: (
        <div className="py-3 px-2 h-screen">
          <PhoneTab
            phoneNumber={applicantInfo?.phone_number}
            email={applicantInfo?.email}
          />
        </div>
      ),
    },
    {
      key: 'case-notes',
      name: L.support.case_notes,
      content: (
        <div className="py-3 px-2 h-screen">
          <CaseNotesTab
            contact={caseInfo.contact}
            applicant={applicantUid}
            channel={channel}
          />
        </div>
      ),
    },
    {
      key: 'tools',
      name: L.support.tools,
      content: (
        <div className="py-3 px-2 h-screen">
          <ToolsTab
            supportCaseId={caseInfo.uid}
            lang={(applicantInfo?.language as SupportedLanguage) || 'en'}
            verified={verifiedContacts || undefined}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="p-3 h-full flex flex-col overflow-hidden">
      <Tabs tabs={tabs} defaultTab="phone" justify="left" />
    </div>
  );
};
